// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rvhc","newExpiryDate":"styles_newExpiryDate__3-lpK","footer":"styles_footer__2BxMu"};